import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { Firm } from '../types/firm';
import { firmHexColourCache } from './cache';

type GetFirmResponse = {
    firm: Firm;
};

const firms = [
    '335fbf86-9d7d-417e-b7fd-8b02f98bfa10',
    '7425a480-2be3-490e-b8da-64fc310d5e5f',
    'f72a7a26-00e9-4ff5-b0f1-605f480baffe',
    '32a50c3c-091e-4256-b01d-9ce12c6ad191',
    'ed84c367-a1d3-4b1f-a90a-4c9ad71ccfff',
    'e0eae079-c12d-469a-b7ee-3ba95976c0f4',
    '3c04323d-174a-4cb3-9369-8e882b8cd4ff',
    '81dfc5ef-1190-4334-be60-5ef86fa4074f',
];

export function generateAvatarColour(data: GetFirmResponse): GetFirmResponse {
    function genColour(id: string): string {
        if (firmHexColourCache[id]) {
            return firmHexColourCache[id];
        }
        const colours = ['#3b82f6', '#22c55e', '#ef4444', '#eab308', '#a855f7'];
        const profileHexColour = colours[Math.floor(Math.random() * colours.length)];
        firmHexColourCache[id] = profileHexColour;

        return profileHexColour;
    }

    data.firm.avatarHexColour = genColour(data.firm.id);
    data.firm.allowedIntegrations = [];
    data.firm.allowedIntegrations.push('fyi');

    if (firms.includes(data.firm.id) || process.env.NODE_ENV !== 'production') {
        data.firm.allowedIntegrations.push('atosa');
    }

    return {
        firm: data.firm,
    };
}

async function getFirm(id: string): Promise<GetFirmResponse> {
    const { data } = await api.get(`/firms/${id}`);
    return data;
}

export function useFirm(id: string, enabled = true): UseQueryResult<GetFirmResponse, AxiosError> {
    return useQuery(['firm', id], () => getFirm(id), { keepPreviousData: false, select: generateAvatarColour, enabled });
}
